import React, { useEffect } from 'react';
import { css } from 'emotion';
import {
  ButtonPrimary,
  TextLink,
  LoadingIndicator,
  ButtonSecondary,
} from '@spotify-internal/encore-web';
import { Modal } from '@spotify-internal/anchor-ds';
import { paths } from 'client/shared/Paths';
import { events } from './events';

function MTSpotifyDistributionModal({
  onClickClose,
  onOptInClick,
  podcastImageFull,
  isLoading,
  isError,
}: {
  onClickClose: () => void;
  onOptInClick: () => void;
  podcastImageFull?: string;
  isLoading: boolean;
  isError: boolean;
}) {
  // analytics
  useEffect(() => {
    events.distributeToSpotifyMTModalScreenViewed();
  }, []);

  return (
    <Modal
      isShowing
      isShowingCloseButton
      aria-labelledby="distribute-top-spotify-title"
      onClose={() => {
        events.distributeToSpotifyMTExitButtonClicked();
        onClickClose();
      }}
    >
      <Modal.Title id="distribute-top-spotify-title">
        Distribute to Spotify
      </Modal.Title>
      <Modal.Subtitle>
        To submit an episode that includes Spotify songs, you’ll need to
        distribute your show to Spotify.
      </Modal.Subtitle>
      {podcastImageFull ? (
        <Modal.Image
          src={podcastImageFull}
          alt="Podcast cover art"
          className={css`
            max-width: 200px;
            max-height: 200px;
            border-radius: 8px;
          `}
        />
      ) : (
        <div
          className={css`
            margin: 20px 0;
          `}
        >
          <LoadingIndicator indicatorSize={LoadingIndicator.sm} />
        </div>
      )}
      {isError && (
        <Modal.Error>
          Hm, something went wrong. Please try again or if the issue persists,
          reach out to us at{' '}
          <TextLink
            href={paths.getHelpPage('home')}
            target="_blank"
            rel="noopener noreferrer"
          >
            {paths.getHelpPage('home')}
          </TextLink>
          .
        </Modal.Error>
      )}
      <Modal.Footer>
        <ButtonSecondary
          as="a"
          onClick={() => {
            events.distributeToSpotifyMTLearnMoreButtonClicked();
          }}
          href="https://anch.co/3iOP2uG"
          target="_blank"
        >
          Learn more
        </ButtonSecondary>
        <ButtonPrimary
          onClick={() => {
            events.distributeToSpotifyMTDistributeButtonClicked();
            onOptInClick();
          }}
          disabled={isLoading}
        >
          {isError ? 'Retry' : 'Publish to Spotify'}
        </ButtonPrimary>
      </Modal.Footer>
    </Modal>
  );
}

export { MTSpotifyDistributionModal };
